// extracted by mini-css-extract-plugin
export default {"control":"Empty_control__tIoR7","wrapper":"Empty_wrapper__8C4vg","title":"Empty_title__jHOEP","name":"Empty_name__ezBfB","page":"Empty_page__8Syh+"};